<template>
  <div style="margin-left: auto; margin-right: auto">
    <div
      class="alert alert-warning border-0 text-center mt-1 align-items-center justify-content-center position-relative"
      role="alert"
      v-show="closeModal"
    >
      <i class="material-icons pr-2" style="font-size: 3em">info</i>
      <p style="text-align: center">PÁGINA EM MANUTENÇÃO!</p>
      <br />
      <p style="text-align: center">
        Estamos trabalhando para resolvermos o mais breve possível.
      </p>
      <br />
      <p style="text-align: center">
        Para solicitações, entre em contato conosco através dos canais abaixo:
      </p>
      <p style="text-align: center">- Telefone: (31) 3249-1666</p>
      <p style="text-align: center">- WhatsApp: (31) 3249-1666</p>
      <p style="text-align: center">- E-mail: relacionamento@cdlbh.com.br</p>
      <p style="text-align: center">- Chat: cdlbh.com.br</p>
      <p style="text-align: center">
        Nosso horário de funcionamento é das 8h às 19h, de segunda à sexta e de
        08h às 14h aos sábados e feriados.
      </p>
      <Botao
        title="Voltar"
        link="/"
        class="btn btn-outline-dark sepia mt-2 fit-content ml-2"
        style="background-color: green; color: white"
        >VOLTAR
      </Botao>
    </div>

    <div class="col-md-12" v-show="statusManutencao">
      <Titulo
        title="Agendamento de Visitas"
        description="Informe os dados necessários para solicitar o agendamento de visistas."
      />
      <form
        class="form_padrao pt-2"
        action
        @submit.prevent="solicitarAgendamento"
      >
        <div class="form-row">
          <div class="form-group flutuante col-md-6 md-6">
            <input
              type="text"
              name="Nome Completo"
              id="nomecompleto"
              required
              v-model="form.nome"
            />
            <label for="nomecompleto">Nome Completo</label>
          </div>
          <div class="form-group flutuante col-md-6">
            <the-mask
              type="text"
              name="telefoneContato"
              id="telefoneContato"
              v-model="form.telefone"
              :mask="['(##) ####-####', '(##) #####-####']"
            />
            <label for="telefoneContato">Telefone de Contato</label>
          </div>
          <div class="form-group flutuante col-md-6">
            <input type="text" name="email" id="email" v-model="form.email" />
            <label for="email">E-mail</label>
          </div>
          <div class="form-group flutuante col-md-6">
            <input
              type="number"
              name="visitantes"
              id="visitantes"
              v-model="form.qtdVisitantes"
              required
            />
            <label for="visitantes">Quantidade de Visitantes</label>
          </div>
        </div>

        <div class="form-row">
          <div
            class="form-group col-md-3 d-flex flex-row justify-content-end align-items-end"
          >
            <button
              type="submit"
              class="btn btn-verde p-0 fit-content"
              :disabled="loading"
            >
              <span
                class="spinner-grow spinner-grow-sm pr-2"
                role="status"
                aria-hidden="true"
                v-show="loading"
              ></span>
              <span v-if="loading">Enviando</span>
              <span v-else>Solicitar Agendamento</span>
            </button>
          </div>
        </div>
      </form>
      <div class="row mt-5 flex-column-reverse flex-md-row">
        <div class="col-md-4 col-lg-2 mt-3 mt-md-0">
          <Botao
            title="Voltar"
            link="/"
            nameClass="btn btn-outline-secondary btn-lg btn-block"
            >VOLTAR</Botao
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { TheMask } from "vue-the-mask";
import Botao from "@/components/botoes/Botao";
import Titulo from "@/components/TituloPaginas";
export default {
  name: "PontoCultural",
  components: {
    TheMask,
    Botao,
    Titulo,
  },
  data() {
    return {
      produto: {
        nome: "Ponto Cultural",
        id: "PontoCultural",
      },
      loading: false,
      form: {
        nome: null,
        telefone: null,
        email: null,
        qtdVisitantes: null,
      },
      closeModal: true,
      statusManutencao: false,
      breadcrumb: [
        {
          nome: "Ponto Cultural",
          id: "pontoCultural",
        },
      ],
    };
  },
  methods: {
    solicitarAgendamento() {
      this.loading = true;
      this.$http
        .post("/api/Agenda/PontoCultural", {
          nome: this.form.nome,
          email: this.form.email,
          telefone: this.form.telefone,
          qtdVisitantes: parseInt(this.form.qtdVisitantes),
        })
        .then(() => {
          this.loading = false;
          this.$toast.open({
            message: "Solicitação enviada com sucesso!",
            type: "success",
          });
          this.form = {};
        })
        .catch((response) => {
          if (response.statusCode === 401) {
            this.$router.push({ name: "login" });
          }
          this.loading = false;
          this.$toast.open({
            message: "Erro no envio da solicitação, tente novamente.",
            type: "error",
          });
        });
    },
    fechaAviso() {
      this.closeModal = false;
    },
  },
  created() {
    this.$store.commit("UPDATE_PRODUTO", this.produto);
    this.$store.commit("UPDATE_BREADCRUMB", this.breadcrumb);
  },
};
</script>

<style lang="scss" scoped>
hr {
  color: #888 !important;
  border-color: rgb(206, 206, 206) !important;
}
</style>
<style lang="scss">
.p-datepicker-title select {
  color: black;
  font-size: 0.8rem;
  width: auto !important;
}
.p-datepicker-title {
  display: flex !important;
}

.listBox {
  border: 0px !important;
  div {
    ul {
      background: #e5e6f1 !important;
    }
  }
}
</style>
